import { NETWORK_ERROR_USER_MESSAGE } from '@labrav/common'
import { AppAlertState } from './reducer'
export enum AppAlertActionTypes {
  UPDATE_APP_ALERT = 'UPDATE_APP_ALERT',
}

export type ErrorActions = {
  type: AppAlertActionTypes.UPDATE_APP_ALERT
}

export const updateAppAlert = (error: AppAlertState) => {
  const isNetworkErrorAlert =
    error.messageType === 'ERROR' &&
    error.message === NETWORK_ERROR_USER_MESSAGE
  console.log('[updateAppAlert-2]', {
    message: error.message,
    messageType: error.messageType,
    remappedToSuccess: isNetworkErrorAlert,
  })
  return {
    type: AppAlertActionTypes.UPDATE_APP_ALERT,
    error: isNetworkErrorAlert
      ? { ...error, messageType: 'SUCCESS' as const }
      : error,
  }
}
